<template>
  <form @submit.prevent="$emit('submit')" class="filter">
    <b-field label="Поиск по категории:" type="is-info" class="course_select">
      <b-select v-model="search.category" placeholder="Категория">
        <option :value="0">Категория</option>
        <option v-for="(category, i) in categoriesList" :key="i" :value="category.id">{{ category.name }}</option>
      </b-select>
    </b-field>
    <b-field label="Поиск по названию курса:" class="course_search input_search with_button" type="is-info">
      <b-input v-model="search.name" placeholder="Введите текст"></b-input>
      <button type="submit">Поиск</button>
    </b-field>
  </form>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    categoriesList: {
      default: () => [],
      type: Array
    }
  }
}
</script>
